import styled from "styled-components";
import { Typography } from "@mui/material";

export const WindowOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  z-index: 9999;
  pointer-events: none;
`;

export const WindowContainer = styled.div`
  position: absolute;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  user-select: none;
  pointer-events: auto;
  z-index: 10000;

  &:hover {
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.4);
  }
`;

export const WindowHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: linear-gradient(180deg, #f5f5f5 0%, #e8e8e8 100%);
  border-bottom: 1px solid #d0d0d0;
  cursor: move;
  user-select: none;
  min-height: 40px;
  touch-action: none;
  -webkit-touch-callout: none;
  width: 100%;
  justify-content: space-between;

  &:active {
    cursor: grabbing;
  }
`;

export const WindowTitle = styled(Typography)`
  flex: 1;
  font-weight: 600 !important;
  font-size: 14px !important;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  align-items: center;
`;

export const WindowControls = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;

  button {
    color: #666;
    transition: all 0.2s;

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
      color: #333;
    }

    &:last-child:hover {
      background-color: #e81123;
      color: white;
    }
  }
`;

export const WindowContent = styled.div`
  flex: 1;
  overflow: auto;
  padding: 16px;
  background-color: #fff;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;

    &:hover {
      background: #555;
    }
  }
`;

interface ResizeHandleProps {
  direction: string;
}

const getResizeHandleStyles = (direction: string) => {
  const baseStyles = `
    position: absolute;
    z-index: 10;
    pointer-events: auto;
  `;

  switch (direction) {
    case "n":
      return `${baseStyles}
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        cursor: ns-resize;
      `;
    case "s":
      return `${baseStyles}
        bottom: 0;
        left: 0;
        right: 0;
        height: 4px;
        cursor: ns-resize;
      `;
    case "e":
      return `${baseStyles}
        top: 0;
        right: 0;
        bottom: 0;
        width: 4px;
        cursor: ew-resize;
      `;
    case "w":
      return `${baseStyles}
        top: 0;
        left: 0;
        bottom: 0;
        width: 4px;
        cursor: ew-resize;
      `;
    case "ne":
      return `${baseStyles}
        top: 0;
        right: 0;
        width: 12px;
        height: 12px;
        cursor: nesw-resize;
      `;
    case "nw":
      return `${baseStyles}
        top: 0;
        left: 0;
        width: 12px;
        height: 12px;
        cursor: nwse-resize;
      `;
    case "se":
      return `${baseStyles}
        bottom: 0;
        right: 0;
        width: 12px;
        height: 12px;
        cursor: nwse-resize;
      `;
    case "sw":
      return `${baseStyles}
        bottom: 0;
        left: 0;
        width: 12px;
        height: 12px;
        cursor: nesw-resize;
      `;
    default:
      return baseStyles;
  }
};

export const ResizeHandle = styled.div<ResizeHandleProps>`
  ${(props) => getResizeHandleStyles(props.direction)}

  &:hover {
    background-color: rgba(255, 128, 56, 0.3);
  }

  &:active {
    background-color: rgba(255, 128, 56, 0.5);
  }
`;
